module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMISav4TwlmGDVg1IBRA4aLAQDFPjEf0fHltwAAAABJRU5ErkJggg=="